// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"BJ","modalContent":"CJ","header":"DJ","close":"EJ"};